import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import rsp from "../../Assets/Projects/rsp.png";
import portfolio1 from "../../Assets/Projects/1web.png";
import movies from "../../Assets/Projects/movies.png";
import rabbit from "../../Assets/Projects/rabbit.png";
import todos from "../../Assets/Projects/todos.png";


function Projects() {
  return (
    <Container fluid className="project-section blend-in-out">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple ">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card ">
            <ProjectCard
              imgPath={rabbit}
              isBlog={false}
              title="Online Clothe Store"
              description="Fully functional e-commerce website using the MERN stack (MongoDB, Express, React, Node.js) along with Redux Toolkit for state management. ."
              ghLink="https://github.com/k-ish-san/E-commerce-MERN"
              demoLink="https://clothestore-peach.vercel.app/"
            />
          </Col>
          
          <Col md={4} className="project-card ">
            <ProjectCard
              imgPath={movies}
              isBlog={false}
              title="MoviesVault"
              description="Movies Vault is a React-based web application that allows users to explore and manage their favorite movies. Built using React JS, Vite, and Tailwind CSS, it integrates with the TMDB API to fetch real-time movie data. Users can browse movies, filter by genre, sort by ratings (ascending/descending), and search within their watchlist."
              ghLink="https://github.com/k-ish-san/Tmdb-clone"
              demoLink="https://tmdb-clone-ticp.vercel.app/"
            />
          </Col>

                 
          <Col md={4} className="project-card ">
            <ProjectCard
              imgPath={todos}
              isBlog={false}
              title="ToDOList"
              description="A simple to do list app."
              ghLink="https://github.com/k-ish-san/todos"
              demoLink="https://todos-tan-kappa.vercel.app//"
            />
          </Col>
            
          <Col md={4} className="project-card ">
            <ProjectCard
              imgPath={rsp}
              isBlog={false}
              title="Rock! Paper! Scissors!"
              description="A Dynamic Rock! Paper! Scissors! game using HTML, CSS and Javascript! The game features an intuitive user interface with a cool, animated Play button. Players choose their move, and the game instantly determines the winner with visually appealing results. "
              ghLink="https://github.com/k-ish-san/Rock-Paper-Scissors"
              demoLink="https://k-ish-san.github.io/Rock-Paper-Scissors/"
            />
          </Col>


            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio1}
              isBlog={false}
              title="Old Portfolio"
              description="This site showcases my skills as a web developer, featuring a clean, responsive design and interactive elements. With a focus on modern web technologies, it highlights my projects, technical expertise, and passion for coding. Built with HTML, CSS and Javascipt"
              ghLink="https://k-ish-san.github.io/"
              demoLink="https://github.com/k-ish-san/k-ish-san.github.io/"
            />
          </Col>

         

            
          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
